import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { userRoles } from 'utils/currentUserRoles';

import Dashboard from 'feature/shipping/Dashboard';
import Batches from 'feature/shipping/batches/Batches';
import ViewBatchById from 'feature/shipping/batches/view/ViewBatchById';
import ViewShipmentById from 'feature/shipping/batches/view/ViewShipmentById';
import Nomination from 'feature/shipping/monthly-nominations/Nomination';

import { useGetAffiliateOptions, useRedirectAffiliateForRole } from 'hooks';

const ShippingRoutes = () => {
  useRedirectAffiliateForRole(
    useGetAffiliateOptions([userRoles.SHIPPER, userRoles.INVENTORY_OWNER])
  );
  return (
    <Routes>
      <Route element={<Dashboard />} index />
      <Route element={<Batches />} path="batches" />
      <Route element={<Batches />} path="batches/:view" />
      <Route element={<ViewBatchById />} path="batches/batch/:batchId" />
      <Route element={<ViewBatchById />} path="batches/batch/:batchId/edit" />
      <Route element={<ViewShipmentById />} path="batches/shipment/:shipmentId" />
      <Route element={<ViewShipmentById />} path="batches/shipment/:shipmentId/edit" />
      <Route element={<Nomination />} path="monthly-nominations/" />
      <Route element={<Nomination />} path="monthly-nominations/:view" />
    </Routes>
  );
};

export default ShippingRoutes;
